// src/pages/Detail2.jsx
import React, { useContext, useEffect, useState } from 'react';
import { FaPhone, FaEnvelope, FaGlobe, FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa";
import { useParams } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import { Carousel } from 'react-responsive-carousel';
import BackButton from '../components/BackButton';
import SearchTabs from '../components/SearchTabs';
import { sanitizeAndParseHtml } from '../utils/HtmlParser';
import PdfViewer from '../components/PdfViewer';
import { contactLog } from '../utils/Accesslog';

function toWhatsAppDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

function openExternalUrl(url) {
  if (!url) return;
  const hasProtocol = /^https?:\/\//i.test(url);
  window.open(hasProtocol ? url : 'https://' + url, '_blank');
}

const Detail2 = () => {
  const { id } = useParams();
  const { contentInfo, hotelInfo, theme, venueId } = useContext(AppContext);
  const [detail, setDetail] = useState(null); //存储内容
  const [history, setHistory] = useState([]); // 历史路由
  useEffect(() => {
    const findNodeById = (tid, node, hist) => {
      const queue = [[node, hist]];
      while (queue.length > 0) {
        const [currentNode, currentHist] = queue.shift();
        if (currentNode.id === tid) return [currentNode, currentHist];
        if (currentNode.attributes) {
          queue.push(...currentNode.attributes.map((data) => [data, [...currentHist, currentNode.name]]));
        }
      }
      return [null, []];
    };

    if (id && contentInfo) {
      const [node, hist] = findNodeById(id, contentInfo, []);
      setDetail(node);
      hist.shift();
      setHistory(hist);
    }
  }, [contentInfo, id]);

  useEffect(() => {
    if (detail?.id === id && detail.externalUrl?.name === 'External' && detail.externalUrl.url) {
      window.location.replace(detail.externalUrl.url);
    }
  }, [detail, id]);

  const openContact = (type, open) => {
    contactLog(venueId, type);
    open();
  };

  if (!hotelInfo) { return <div>Loading...</div>; }
  if (detail?.id === id && detail.externalUrl?.url) {
    if (detail.externalUrl.name === 'PDF') return <PdfViewer src={detail.externalUrl.url} />;
    if (detail.externalUrl.name === 'External') return null;
  }

  const discoverHeader = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.discoverHeader || 'rgb(0,0,0)');
  const discoverBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : theme?.discoverBackground || 'rgb(255,255,255)';


  return (
    <div style={{ backgroundColor: discoverBackground }} className='flex-1'>
      <SearchTabs />
      <BackButton />
      {history && history.length > 0 && <div className='py-2 px-4 bg-white'>
        {history && history.length > 0 && history.map((name) => (
          <span key={name} className='text-sm'>&nbsp;{name}&nbsp;&gt;</span>))}
        {detail && <span className='font-semibold text-sm'>&nbsp;{detail.name}</span>}
      </div>}
      <div className='px-4 pt-2 pb-4 text-2xl font-semibold' style={{ color: discoverHeader }}>
        {detail && detail.name}
      </div>
      {detail && detail.isLeaf && <div className='px-4'>
        {detail && detail.carouselImages && detail.carouselImages.length > 0 && (
          detail.carouselImages.length <= 1 ?
            <img src={detail.carouselImages[0]} alt='homeImage' className='object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64 rounded-md' />
            :
            <Carousel
              showArrows={true}
              showThumbs={false}
              infiniteLoop={true}
              autoPlay={true}
              showIndicators={false}
              showStatus={false}
              className="w-full h-full rounded-md"
            >
              {detail.carouselImages.map((url, index) => (
                <div key={index} className="w-full h-full">
                  <img
                    src={url}
                    alt={`Home Adv ${index + 1}`}
                    className="object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64"
                  />
                </div>
              ))}
            </Carousel>)}
        <div className='content-body pt-6 pb-2 text-sm border-x-2 border-b-2 px-4'>
          <div>
            {sanitizeAndParseHtml(detail.mainText || '', venueId)}
          </div>
          {detail && detail.contact && (
            <div className='mt-2 px-4'>
              {(detail.contact.phone || detail.contact.email || detail.contact.website) && <span className='font-semibold text-lg'>Find us on</span>}
              <div className="mt-2 flex space-x-8 items-center w-3/4">
                {detail.contact.phone && (
                  <button type="button" aria-label="Call"
                    className="cursor-pointer"
                    onClick={() => openContact('Phone', () => window.open(`tel:${detail.contact.phone}`))}
                  >
                    <FaPhone className="text-green-500 w-6 h-6" />
                  </button>
                )}
                {detail.contact.email && (
                  <button type="button" aria-label="Email"
                    className="cursor-pointer"
                    onClick={() => openContact('Email', () => window.open(`mailto:${detail.contact.email}`))}
                  >
                    <FaEnvelope className="text-blue-500 w-6 h-6" />
                  </button>
                )}
                {detail.contact.website && (
                  <button type="button" aria-label="Website"
                    className="cursor-pointer"
                    onClick={() => openContact('Website', () => openExternalUrl(detail.contact.website))}
                  >
                    <FaGlobe className="text-gray-500 w-6 h-6" />
                  </button>
                )}
                {detail.contact.whatsapp && (
                  <button type="button" aria-label="WhatsApp"
                    className="cursor-pointer"
                    onClick={() => {
                      const digits = toWhatsAppDigits(detail.contact.whatsapp);
                      if (digits) {
                        openContact('Whatsapp', () => window.open(`https://wa.me/${digits}`, '_blank'));
                      }
                    }}
                  >
                    <FaWhatsapp className="text-green-500 w-6 h-6" />
                  </button>
                )}
                {detail.contact.facebook && (
                  <button type="button" aria-label="Facebook"
                    className="cursor-pointer"
                    onClick={() => openContact('Facebook', () => openExternalUrl(detail.contact.facebook))}
                  >
                    <FaFacebook className="text-blue-800 w-6 h-6" />
                  </button>
                )}
                {detail.contact.instagram && (
                  <button type="button" aria-label="Instagram"
                    className="cursor-pointer"
                    onClick={() => openContact('Instagram', () => openExternalUrl(detail.contact.instagram))}
                  >
                    <FaInstagram className="text-pink-500 w-6 h-6" />
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>}
    </div>
  );
};

export default Detail2;

